
        var result = require("!!../../../node_modules/css-loader/index.js!./menu.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/menu/menu.component.css
// module id = 2129
// module chunks = 1